/* The Easter egg hunt (owner request 2026-10-31), the pure part: the season, the chance and the wait between eggs, which
   egg comes next, where it may go, and the messages. Part of "Little surprises" (the same switch turns it off). No
   screen, no storage: the screen part is src/eggs.ts. Tested in tests/app/eggs.test.ts. Never names the old product. */
import {easter} from './holidays.ts';

const p2 = (n: number) => String(n).padStart(2, '0');
const shift = (date: string, days: number) => {
  const d = new Date(Date.UTC(+date.slice(0, 4), +date.slice(5, 7) - 1, +date.slice(8, 10)) + days * 86400000);
  return d.getUTCFullYear() + '-' + p2(d.getUTCMonth() + 1) + '-' + p2(d.getUTCDate());
};
/** the hunt's days in a year: Good Friday through Easter Monday (2027: Mar 26-29) */
export function eggSeason(y: number): {from: string; to: string} { const e = easter(y); return {from: shift(e, -2), to: shift(e, 1)}; }
/** is the hunt on, on this date ('YYYY-MM-DD', the person's own day in their zone)? */
export function eggSeasonOn(date: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const s = eggSeason(+date.slice(0, 4));
  return date >= s.from && date <= s.to;
}

export const EGG_COUNT = 12;
/** about 1 tap in 6 shows an egg; at least 20 s between eggs; an egg not tapped goes away after 6 s */
export const EGG_CHANCE = 1 / 6, EGG_COOLDOWN = 20_000, EGG_LIFE = 6000;
/** may this tap show an egg? (r: a random number 0-1; lastAt: when the last egg appeared, 0 = never) */
export function eggRoll(now: number, lastAt: number, onScreen: boolean, r: number, chance = EGG_CHANCE): boolean {
  return !onScreen && now - lastAt >= EGG_COOLDOWN && r < chance;
}
/** the next egg to show: one not found yet (r: random 0-1); null when all 12 are found (the hunt is over for the year) */
export function nextEgg(found: number[], r: number): number | null {
  const left = Array.from({length: EGG_COUNT}, (_, i) => i).filter(i => !found.includes(i));
  return left.length ? left[Math.min(left.length - 1, Math.floor(r * left.length))] : null;
}
/** the found list after collecting egg n (no duplicates, nothing outside 0-11) */
export const collect = (found: number[], n: number) => n >= 0 && n < EGG_COUNT && !found.includes(n) ? [...found, n] : found;
/** what a stored value says was found (anything odd counts as nothing) */
export function parseFound(raw: string | null): number[] {
  try { const v = JSON.parse(raw || '[]'); return Array.isArray(v) ? [...new Set(v.filter((n): n is number => Number.isInteger(n) && n >= 0 && n < EGG_COUNT))] : []; } catch { return []; }
}
export const foundText = (n: number) => n >= EGG_COUNT ? '🐣 You found all 12! Happy Easter.' : `🥚 ${n} of ${EGG_COUNT} found`;

/** places to try for an egg w x h near a tap at (x, y), nearest first, all fully inside the visible area (with a margin):
    rings of 12 spots at 44 to 270 px from the tap. Each is the egg's top-left corner. */
export function eggSpots(x: number, y: number, vw: number, vh: number, w = 30, h = 38, margin = 8): {x: number; y: number}[] {
  const out: {x: number; y: number}[] = [];
  for (const d of [44, 70, 100, 135, 175, 220, 270]) for (let k = 0; k < 12; k++) {
    const a = (k / 12 + (d % 3) / 24) * Math.PI * 2;
    const left = Math.round(x + Math.cos(a) * d - w / 2), top = Math.round(y + Math.sin(a) * d - h / 2);
    if (left >= margin && top >= margin && left + w <= vw - margin && top + h <= vh - margin) out.push({x: left, y: top});
  }
  return out;
}
